import { IntlShape } from 'react-intl';

export const getAriaVoumeCurrentValue = (
    intl: IntlShape,
    percent: number,
    isMuted: boolean
): string =>
    isMuted
        ? intl.formatMessage({
              id: 'features.player.bed87356b66f3046dff890d78d1a415a',
              defaultMessage: 'Sound off',
              description: 'ARIA описание для отключенного звука в слайдере громкости',
          })
        : intl.formatMessage(
              {
                  id: 'features.player.918c56a4c124a2ce47a20d652e3b4e97',
                  defaultMessage: 'Volume {percent}%',
                  description: 'ARIA описание уровня громкости в слайдере громкости',
              },
              { percent }
          );
